var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMagazineGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_238_2914",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_238_2914)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.2647 17.1765L17.6765 12.7647H14.0622C13.8363 12.7647 13.6468 12.8411 13.494 12.994C13.3411 13.1468 13.2647 13.3363 13.2647 13.5622V17.1765ZM5.59503 18.5C5.1564 18.5 4.78091 18.3438 4.46855 18.0314C4.15618 17.7191 4 17.3436 4 16.905V5.09503C4 4.6564 4.15618 4.28091 4.46855 3.96855C4.78091 3.65618 5.1564 3.5 5.59503 3.5H17.405C17.8436 3.5 18.2191 3.65618 18.5314 3.96855C18.8438 4.28091 19 4.6564 19 5.09503V12.6731C19 12.8882 18.9587 13.0933 18.8761 13.2883C18.7935 13.4834 18.6799 13.6533 18.5351 13.7981L14.2981 18.0351C14.1533 18.1799 13.9834 18.2935 13.7883 18.3761C13.5933 18.4587 13.3882 18.5 13.1731 18.5H5.59503ZM8.14028 12.5271H10.8383C11.0257 12.5271 11.1829 12.4637 11.3097 12.3368C11.4366 12.2099 11.5 12.0527 11.5 11.8651C11.5 11.6775 11.4366 11.5204 11.3097 11.3937C11.1829 11.267 11.0257 11.2036 10.8383 11.2036H8.14028C7.95278 11.2036 7.79561 11.2671 7.66877 11.394C7.54194 11.5209 7.47853 11.6781 7.47853 11.8657C7.47853 12.0533 7.54194 12.2104 7.66877 12.3371C7.79561 12.4638 7.95278 12.5271 8.14028 12.5271ZM8.14028 9.01468H14.8597C15.0472 9.01468 15.2044 8.95124 15.3312 8.82435C15.4581 8.69746 15.5215 8.54022 15.5215 8.35265C15.5215 8.16506 15.4581 8.00792 15.3312 7.88123C15.2044 7.75454 15.0472 7.69119 14.8597 7.69119H8.14028C7.95278 7.69119 7.79561 7.75463 7.66877 7.88151C7.54194 8.00841 7.47853 8.16565 7.47853 8.35322C7.47853 8.54081 7.54194 8.69795 7.66877 8.82464C7.79561 8.95133 7.95278 9.01468 8.14028 9.01468Z",
    fill: "#1EB65B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagazineGreen);
export default __webpack_public_path__ + "static/media/magazine_green.463a888719bf426e95b53d4354e69465.svg";
export { ForwardRef as ReactComponent };